/* eslint-disable */
import React from "react"
import ReactDOM from "react-dom"
import { injectGlobal } from "styled-components"
import config from "./config"
import styles from "theme/style.css"
import App from "./App"

import Analytics from 'utils/analytics';

injectGlobal`
  ${styles.toString()}
`
;(function(p, l, o, w, i, n, g) {
  if (!p[i]) {
    p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || []
    p.GlobalSnowplowNamespace.push(i)
    p[i] = function() {
      ;(p[i].q = p[i].q || []).push(arguments)
    }
    p[i].q = p[i].q || []
    n = l.createElement(o)
    g = l.getElementsByTagName(o)[0]
    n.async = 1
    n.src = w
    g.parentNode.insertBefore(n, g)
  }
})(window, document, "script", "https://d1fc8wv8zag5ca.cloudfront.net/2.5.1/sp.js", "spSnowplowTracker")

for (const stage in config.SNOWPLOW_COLLECTORS) {
  window.spSnowplowTracker("newTracker", `${stage}-player`, config.SNOWPLOW_COLLECTORS[stage])
}

window.SpokenLayerPlayer = App

const ready = (callback) => {
  // in case the document is already rendered
  if (document.readyState !== 'loading') {
    callback()
  }
  // modern browsers
  else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', callback);
  }
  // IE <= 8
  else document.attachEvent('onreadystatechange', function() {
    if (document.readyState === 'complete') callback();
  });
}

ready(function() {
  const playerRootNodes = document.querySelectorAll(".spokenlayer")

  for (const playerRootNode of playerRootNodes) {
    const {
      key = 'default',
      iframe,
      type,
      autoplay,
      playlist,
      publication,
      border,
      share,
      theme,
      shareTheme,
      variant,
      hideWhenEmpty,
      continueWithPublicationPlaylist,
    } = playerRootNode.dataset

    const analytics = new Analytics(key, publication)
    const { width } = playerRootNode.getBoundingClientRect()

    analytics.trackPlayerInit(
      {
        publication,
        playlist,
      },
      {
        iframe,
        type,
        autoplay,
        border,
        share,
        theme,
        shareTheme,
        variant,
        hideWhenEmpty,
      },
      width
    )

    ReactDOM.render(
      <App
        appKey={key}
        analytics={analytics}
        autoplay={autoplay === undefined ? autoplay : autoplay === "true"}
        publication={publication}
        playlist={playlist}
        border={border === undefined ? border : border === "true"}
        type={type}
        share={share === undefined ? share : share === "true"}
        iframe={iframe === undefined ? iframe : iframe === "true"}
        theme={theme}
        shareTheme={shareTheme}
        variant={variant}
        hideWhenEmpty={
          hideWhenEmpty === undefined
            ? hideWhenEmpty
            : hideWhenEmpty === "true" || hideWhenEmpty === true
        }
        continueWithPublicationPlaylist={continueWithPublicationPlaylist === "true"}
      />,
      playerRootNode
    )
  }
})

window.WebPlayer = {
  mount: (args, player) => {
    const {
      id,
      key = 'default',
      iframe,
      type,
      autoplay,
      playlist,
      publication,
      border,
      share,
      theme,
      shareTheme,
      variant,
      hideWhenEmpty,
    } = args
    const analytics = new Analytics(key, publication)
    const { width } = player.getBoundingClientRect()

    analytics.trackPlayerInit(
      {
        publication,
        playlist,
      },
      {
        iframe,
        type,
        autoplay,
        border,
        share,
        theme,
        shareTheme,
        variant,
        hideWhenEmpty,
      },
      width
    )

    ReactDOM.render(
      <App
        customPlayerSettings={args}
        id={id}
        appKey={key}
        analytics={analytics}
        autoplay={autoplay === undefined ? autoplay : autoplay === "true"}
        publication={publication}
        playlist={playlist}
        border={border === undefined ? border : border === "true"}
        type={type}
        share={share === undefined ? share : share === "true"}
        iframe={iframe !== undefined ? iframe : false}
        theme={theme}
        shareTheme={shareTheme}
        variant={variant}
        hideWhenEmpty={
          hideWhenEmpty === undefined
            ? hideWhenEmpty
            : hideWhenEmpty === "true" || hideWhenEmpty === true
        }
      />,
      player
    )
  },
  unmount: (player) => {
    ReactDOM.unmountComponentAtNode(player)
  },
}



// WEBPACK FOOTER //
// ./src/index.js